import React from "react";
import "moment/locale/ja";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import calendar from "../../assets/images/calendar.png";

const DATE_FMT = "YYYY/MM/DD HH:mm:ss";

class CustomInput extends React.PureComponent {
  render() {
    const { onClick } = this.props;

    return (
      <button
        style={{
          marginTop: "9px",
          fontSize: "16px",
          fontFamily: "inherit",
          width: "40px",
          height: "33px",
          borderRadius: "4px",
          backgroundColor: "white",
          textAlign: "center"
        }}
        onClick={onClick}
      >
        <img src={calendar} alt="" style={{ width: "100%", height: "100%" }} />
      </button>
    );
  }
}

const DatePicker = props => {
  return (
    <ReactDatePicker
      customInput={<CustomInput />}
      showTimeSelect
      disabledKeyboardNavigation
      dateFormat="LLL"
      timeFormat="HH:mm"
      locale="ja"
      timeCaption="時間"
      minDate={moment().toDate()}
      selected={
        props.selectedDate ? moment(props.selectedDate, DATE_FMT) : null
      }
      onChange={date => date && props.onChange(date.format(DATE_FMT))}
    />
  );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/uis/CustomDatePicker/index.jsx